<template>
  <div>
    <div class="row"></div>
    <div class="col s12 z-depth-1 white">
      <div class="col s3 dateSelect">
        <DatePicker v-model="date" :max-date="maxDate" style="padding-right: 6px;" @dateChanged="datePickerChanged"/>

        <PeriodSelector v-model="selectedPeriod" />
      </div>
      <div class="col s3">
        <div class="input-field">
          <select v-model="module" class="browser-default">
            <option v-for="module in modules" :value="module.id" :key="module.id">
              {{ module.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row"></div>
    <XYAnalysis
      v-if="module === 'xy'"
      :rail-object="railObject"
      :timeSelection="date" />
    <HistogramAnalysis
      v-if="module === 'hist'"
      :rail-object="railObject"
      :timeSelection="date" />
    <ComplexAnalysis
      v-if="module === 'complex'"
      :rail-object="railObject"
      :complex-object="complexObject"
      :timeSelection="date" />
    <SwitchOverviewAnalysis
      v-if="module === 'switchOverview'"
      :rail-object="railObject"
      :complex-object="complexObject"
      :timeSelection="date" />
    <SectionAnalysis
      v-if="module === 'section'"
      :rail-object="railObject"
      :date-from="date.start"
      :date-to="date.end" />
    <HealthAnalysis
      v-if="module === 'health'"
      :timeSelection="date"
      :rail-object="railObject" />
    <DetectionAnalysis
      v-if="module === 'detections'"
      :rail-object="railObject" />
    <HeatmapAnalysis
      :timeSelection="date"
      :rail-object="railObject"
      v-if="module === 'heatmap'" />
  </div>
</template>

<script>
import SectionAnalysis from '../../components/switch/analysis/SectionAnalysis'
import HistogramAnalysis from '../../components/switch/analysis/HistogramAnalysis'
import XYAnalysis from '../../components/switch/analysis/XYAnalysis'
// import HealthAnalysis from '../../components/switch/analysis/HealthAnalysis'
import HealthAnalysis from '../../pages/switch/_analysis/HealthScores'
import HeatmapAnalysis from '../../components/switch/analysis/HeatmapAnalysis'
import DetectionAnalysis from '../../components/switch/analysis/DetectionAnalysis'
import moment from 'moment'
import DatePicker from '../../components/switch/DatePicker'
import PeriodSelector from '../../components/PeriodSelector'
import ComplexAnalysis from '../../components/switch/analysis/ComplexAnalysis'
import SwitchOverviewAnalysis from '../../components/switch/analysis/SwitchOverviewAnalysis'

export default {
  name: 'Analysis',
  props: {
    railObject: {
      type: Object,
      required: true
    },
    complexObject: {
      type: Object,
      required: true
    }
  },
  components: {
    DatePicker,
    XYAnalysis,
    ComplexAnalysis,
    HistogramAnalysis,
    SectionAnalysis,
    DetectionAnalysis,
    HealthAnalysis,
    HeatmapAnalysis,
    PeriodSelector,
    SwitchOverviewAnalysis
  },
  data () {
    return {
      module: 'xy',
      modules: [
        { id: 'xy', name: this.$t('analysis.xyAnalysis') },
        { id: 'hist', name: this.$t('analysis.histogram') },
        { id: 'complex', name: this.$t('analysis.complex') },
        { id: 'switchOverview', name: this.$t('analysis.switchOverview') },
        // { id: 'section', name: this.$t('analysis.sectionAnalysis') },
        // { id: 'detections', name: this.$t('analysis.detections') },
        { id: 'health', name: this.$t('analysis.healthScores') },
        { id: 'heatmap', name: this.$t('analysis.heatmap') }
      ],
      date: {
        start: moment().subtract(1, 'month'),
        end: moment()
      },
      selectedPeriod: '1month'
    }
  },
  created: function () {
    this.setLastMeasurementDate()
  },
  computed: {
    startDate () {
      return moment(this.date.start).format('DD-MM-YY')
    },
    endDate () {
      return moment(this.date.end).format('DD-MM-YY')
    },
    maxDate () {
      if (this.railObject && this.railObject.MeasurementSet.TriggeredMeasurements[0]) {
        return moment(this.railObject.MeasurementSet.TriggeredMeasurements[this.railObject.MeasurementSet.TriggeredMeasurements.length - 1].MeasurementDateTime).toDate()
      } else {
        return new Date()
      }
    },
    selectablePeriods () {
      switch (this.module) {
        default:
          return {
            '1week': 'Last week',
            '2weeks': 'Last 2 weeks',
            '1month': 'Last month',
            '3months': 'Last 3 months',
            '6months': 'Last 6 months',
            '1year': 'Last  year'
          }
      }
    }
  },
  methods: {
    setLastMeasurementDate () {
      if (this.railObject) {
        const triggeredMeasurements = this.railObject.MeasurementSet.TriggeredMeasurements
        const length = triggeredMeasurements.length
        if (length > 0) {
          this.selectedPeriod = '1month'
          const end = moment(triggeredMeasurements[length - 1].MeasurementDateTime)
          const start = this.getStartDate(end)
          this.date = {
            start,
            end
          }
        }
      }
    },
    getStartDate (endDate) {
      switch (this.selectedPeriod) {
        case '1week':
          return moment(endDate).subtract(1, 'weeks')
        case '2weeks':
          return moment(endDate).subtract(2, 'weeks')
        case '1month':
          return moment(endDate).subtract(1, 'months')
        case '3months':
          return moment(endDate).subtract(3, 'months')
        case '6months':
          return moment(endDate).subtract(6, 'months')
        case '1year':
          return moment(endDate).subtract(1, 'years')
        default:
          return moment(endDate).subtract(1, 'months')
      }
    },
    datePickerChanged () {
      this.selectedPeriod = 'user_input'
    }
  },
  watch: {
    selectedPeriod (period) {
      if (period === 'user_input') {
        return
      }
      const end = moment().endOf('day')
      const start = this.getStartDate(end)
      this.date = {
        start,
        end
      }
    }
  }
}
</script>

<style>
.control select {
  /*display: block !important;*/
  height: 30px;
}

.dateSelect {
  padding-top: 20px !important;
}

.popover-container {
  display: inline-block;
}

.buttonbg {
  background: #56CCF2;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}

.title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>



// WEBPACK FOOTER //
// src/pages/switch/Analysis.vue